export const Footer = () => {
  return (
    <footer className="mx-auto w-full max-w-2xl px-6 sm:px-8 pb-24 sm:pb-10">
      <div className="pt-8 border-t border-ink-100 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between font-mono text-xs text-ink-400 tracking-wider">
        <span>NISHINO0719 · 福岡</span>
        <span>
          Cat: CatsAssets 32x32 Edition ·{' '}
          <a
            href="https://creativecommons.org/licenses/by/4.0/"
            target="_blank"
            rel="noopener noreferrer license"
            className="underline decoration-ink-400/30"
          >
            CC BY 4.0
            <span className="sr-only">（外部サイト、新しいタブで開く）</span>
          </a>
        </span>
      </div>
    </footer>
  )
}
